import type {preSaveTier, PromotionTier} from '@/pages/Promotions/types';
import {logger} from '@/utils/logger';

import axiosApiInstance from './axios';

export async function getTiers(): Promise<PromotionTier[]> {
  const response =
    await axiosApiInstance.get<PromotionTier[]>('/v2/admin/tiers');
  return response.data;
}

export async function getTier(id: string): Promise<PromotionTier> {
  const response = await axiosApiInstance.get<PromotionTier>(
    `/v2/admin/tiers/${id}`,
  );
  return response.data;
}

export async function createTier(tier: preSaveTier): Promise<PromotionTier> {
  try {
    const response = await axiosApiInstance.post<PromotionTier>(
      '/v2/admin/tiers',
      tier,
    );
    return response.data;
  } catch (error) {
    logger.error('Error creating tier:', error);
    throw error;
  }
}

export async function updateTier(
  id: string,
  tier: Partial<PromotionTier>,
): Promise<PromotionTier> {
  try {
    const response = await axiosApiInstance.patch<PromotionTier>(
      `/v2/admin/tiers/${id}`,
      tier,
    );
    return response.data;
  } catch (error) {
    logger.error('Error updating tier:', error);
    throw error;
  }
}

export async function updateTierForUser(
  userId: string,
  tierId?: string,
): Promise<unknown> {
  try {
    const response = await axiosApiInstance.patch<unknown>(
      `/v2/admin/users/${userId}/tiers/${tierId || ''}`,
      {tierId},
    );
    return response.data;
  } catch (error) {
    logger.error('Error updating tier:', error);
    throw error;
  }
}

export const deleteTierForUser = async (id: string): Promise<unknown> => {
  try {
    const response = await axiosApiInstance.delete<unknown>(
      `/v2/admin/users/${id}/tiers`,
    );
    return response.data;
  } catch (error) {
    logger.error('Error deleting tier:', error);
    throw error;
  }
};
